import { innerRouter, pagePath } from '@/common/jump'
import { goto, is } from '@didi/spring-base'
import store from '@/store'

export const to12306LoginPage = params => {
  const userInfo12306 = store.state.login12306.userInfo12306
  const commonParams = {}
  const loginStatus = userInfo12306?.account_with_star
  const cxvip = userInfo12306?.cxvip
  if (!loginStatus || (loginStatus && !cxvip)) {
    commonParams.cxvip = 'popup'
  }
  innerRouter.push(pagePath().LOGIN12306, {
    ...commonParams,
    ...params
  })
}

export const toScanDualDesc = () => {
  innerRouter.push(pagePath().ICKETPURCHASENOTICE, { checkTabIndex: 'scramble' })
}

export const gotoPurchaseInformationPage = ({ type = '', source='' }) => {
  if (type === 'train') {
    innerRouter.push(pagePath().HOMESERVICE, {
      actionType: 'help',
      source
    })
  }
  else if (type === 'flights') {
    goto({
      url: 'https://v.didi.cn/Lol3QQA', 
      params: {
        actionType: 'help',
        source
      }
    })
  }
}